import Vue from 'vue'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

//import Toasted from 'vue-toasted'
//Vue.use(Toasted)

Vue.component(
    'form-inmobiliaria',
    require('../../componentes/sitio/FormularioInmobiliaria.vue').default
)

Vue.config.productionTip = false
Vue.config.devtools = false

if (document.getElementById('vue-form-inmobiliaria')) {
    new Vue({
        el: '#vue-form-inmobiliaria'
    })
}
